import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Settings } from 'src/app/settings/settings.service';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { HttpHeaderType } from 'src/app/shared/enum/headerType.enum';
@Injectable()

export class RESTService {

    private _headers: HttpHeaders;

    constructor(private _http: HttpClient, private _settings: Settings) {
        this._headers = this._settings.httpOptions.headers;
    }

    /**
     * Change headers by number
     * Please see \Settings for more information
     * @param type number
     */
    public setHttpHeader(type: HttpHeaderType = HttpHeaderType.JSON) {
        switch (type) {
            case HttpHeaderType.JSON:
                this._headers = this._settings.httpOptions.headers;
                break;
            case HttpHeaderType.FORM_DATA:
                this._headers = this._settings.httpOptions.headersFormData;
                break;
            default:
                break;
        }
    }

    /**
     * Returns data from a _http get url
     * Used for get routes
     * @param url
     * @param data
     */
    public get(url: any): Observable<any> {
        // console.log('Rest: GET');
        // console.log(this);
        return this._http.get(this._settings.apiUrl + url, {headers: this._headers});
    }

    /**
     * POST data to a _http Post url
     * Used for create routes
     * @param url
     * @param data
     */
    public post(url: string, data: any) {
        // console.log('Rest: POST');
        // console.log(data);
        return this._http.post(this._settings.apiUrl + url, data);
    }

    /**
     * PUT data to a _http Put url
     * Used for update routes
     * @param url
     * @param data
     */
    public put(url: string, data: any) {
        // console.log('Rest: PUT');
        // console.log(data);
        return this._http.put(this._settings.apiUrl + url, data, {headers: this._headers});
    }

    /**
     * DELETE data from a _http detele url
     * Used for delete routes
     * @param url
     * @param data
     */
    public delete(url: string) {
        // console.log('Rest: DELETE');
        // console.log(this);
        return this._http.delete(this._settings.apiUrl + url, {headers: this._headers});
    }

    public getPing() { // Check if API is working and responding
        return this.get('ping');
    }
}
